import { isCommandError, runCommand } from '../../services/appwrite/command-gateway';
import type { BugReport } from '../admin/admin-gateway';

export type { BugReport };

export interface BugReportInput {
  title: string;
  url: string;
  details: string;
  suggestion?: string;
  impact: 'minor' | 'partial' | 'blocking';
}

export interface BugReportGateway {
  create(input: BugReportInput): Promise<{ report: BugReport; message: string }>;
  getOwn(reportId: string): Promise<BugReport>;
}

export const bugReportGateway: BugReportGateway = {
  create: (input) => runCommand('create_bug_report', { ...input }),
  async getOwn(reportId) {
    const result = await runCommand<{ report: BugReport }>('get_own_bug_report', { reportId });
    return result.report;
  },
};

const MESSAGES: Record<string, string> = {
  bug_title_required: 'Escribe un título que resuma el error.',
  bug_title_too_long: 'El título no puede superar los 200 caracteres.',
  bug_url_required: 'Indica en qué dirección encontraste el error.',
  bug_url_too_long: 'La dirección es demasiado larga.',
  bug_details_required: 'Cuéntanos el error con un poco más de detalle (al menos 10 caracteres).',
  bug_details_too_long: 'El detalle no puede superar los 5000 caracteres.',
  bug_suggestion_too_long: 'La sugerencia no puede superar los 2000 caracteres.',
  bug_impact_invalid: 'Selecciona cuánto te afecta el error.',
  bug_report_required: 'Elige el reporte que quieres consultar.',
  bug_report_not_found: 'No encontramos ese reporte, o no te pertenece.',
};

export function bugReportErrorText(error: unknown): string {
  const known = isCommandError(error) ? MESSAGES[error.code] : undefined;
  return known ?? 'No pudimos completar la acción. Inténtalo de nuevo.';
}
